import KeplerBackofficeSdk from '../lib/kepler/backoffice'

const state = {
    user: null,
    token: null,
    logged_in: false,

  isRoot: false,
  userPermissions: [],
  menuPermissions: []
}

const mutations = {
    SET_USER (state, user) {
        state.user = user
        state.logged_in = true
    },
    SET_TOKEN (state, token) {
        state.token = token
    },
  SET_IS_ROOT(state, user) {
    const role = user.roles.find((item) => {
      return item.name === 'ROOT'
    })
    state.isRoot = role !== undefined && role.name === 'ROOT'
  },
  SET_USER_PERMISSIONS(state, user) {
    state.userPermissions = user.roles.flatMap((item) => {
      return item.permissions
    })
  },
  SET_MENU_PERMISSIONS(state) {
    state.menuPermissions = state.userPermissions.filter((item) => {
      return item.name.startsWith('menu_')
    })
  }
}

const actions = {
    login: ({commit}, payload) => {

    return new Promise((resolve) => {

      commit('SET_USER', payload)
      commit('SET_IS_ROOT', payload)
      commit('SET_USER_PERMISSIONS', payload)
      commit('SET_MENU_PERMISSIONS')
      resolve(state)
    })

    },
    setToken: ({commit}, payload) => {
        commit('SET_TOKEN', payload)
        localStorage.setItem('token', payload)
    },

  profile: ({commit}) => {
    return KeplerBackofficeSdk.users.profile().then((response) => {
      commit('SET_USER', response.data)
      commit('SET_IS_ROOT', response.data)
    })
  },
  test({commit}) {
    commit('SET_IS_ROOT', state.user)

  }
}

export default {
    state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/userStore.js